module.exports = __webpack_public_path__ + "static/media/plants2.bff866df.jpg";